import {
    selectLayoutPanelId,
    useLayoutSelector,
    useSelectPendingLayout,
} from 'layout/store/selectors';
import OverlayPanel from 'utils/components/OverlayPanel/OverlayPanel';
import React, { useEffect } from 'react';
import { isLayoutEmpty } from 'layout/LayoutState';
import { useDispatchClearPendingLayout } from 'layout/store/dispatcher';
import { useSelector } from 'react-redux';

export interface PendingLayoutOverlayPanelProps {
    height?: number;
    top?: number;
}
export function PendingLayoutOverlayPanel(
    props: PendingLayoutOverlayPanelProps
) {
    const { top, height } = props;
    const pendingLayout = useSelectPendingLayout();
    const layoutPanelId = useSelector(selectLayoutPanelId);
    const activeLayout = useLayoutSelector();
    const dispatchClearPendingLayout = useDispatchClearPendingLayout();

    useEffect(() => {
        if (
            (pendingLayout?.name === activeLayout?.name ||
                (layoutPanelId && pendingLayout?.panelId === layoutPanelId)) &&
            isLayoutEmpty(activeLayout)
        ) {
            dispatchClearPendingLayout();
        }
    }, [
        pendingLayout,
        activeLayout,
        dispatchClearPendingLayout,
        layoutPanelId,
    ]);

    if (!pendingLayout) {
        return <></>;
    }

    return (
        <OverlayPanel
            height={height}
            top={top}
            className="PendingLayoutOverlayPanel"
        >
            <div className="ui active inline loader mini" />
            {pendingLayout.panelId
                ? 'Loading Panel'
                : 'Loading Layout ' + pendingLayout.name}
            ...
        </OverlayPanel>
    );
}
